import { useEffect } from "react";

const EVERWEBINAR_SCRIPT_ID = "everwebinar-embed-script-5yy5wul";
const EVERWEBINAR_SCRIPT_SRC = "https://event.webinarjam.com/register/5yy5wul/embed-button?formTemplate=2&formColor=1&buttonText=Register";

export default function EverWebinarPopupBridge() {
  useEffect(() => {
    let script = document.getElementById(EVERWEBINAR_SCRIPT_ID);
    const alreadyPresent = Boolean(script);

    if (!script) {
      script = document.createElement("script");
      script.id = EVERWEBINAR_SCRIPT_ID;
      script.src = EVERWEBINAR_SCRIPT_SRC;
      script.async = true;
      script.setAttribute("data-everwebinar-route", "/mesterkurzus");
      document.body.appendChild(script);
    }

    return () => {
      if (!alreadyPresent) {
        const ownedScript = document.getElementById(EVERWEBINAR_SCRIPT_ID);
        ownedScript?.remove();
      }
    };
  }, []);

  return null;
}